<template>
  <div class="tw-min-w-[1200px]">
    <ForeignersListHeader />

    <div class="tw-mb-8">
      <ForeignerFamilyHead
        v-for="foreigner in foreigners"
        :key="foreigner.id"
        :foreigner="foreigner"
      />
    </div>
  </div>
</template>

<script>
import ForeignersListHeader from '@/components/Foreigners/List/ForeignersListHeader.vue';
import ForeignerFamilyHead from '@/components/Foreigners/List/ForeignerFamilyHead.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ForeignerFamilyHead,
    ForeignersListHeader,

  },
  computed: {
    ...mapState({
      foreigners: (state) => state.v2.admin.foreigners.foreigners.foreigners,
    }),
  },
};
</script>
